import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalService} from "@azure/msal-angular";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import {AuthService} from "./app/shared/service/auth.service";
import {BsPreset} from "./bs-theme-preset";
import {provideStore, StoreModule} from "@ngrx/store";
import {globalConfigReducer} from "./app/global-config/state/global-config/global-config.reducer";
import {
  globalConfigDropdownReducer
} from "./app/global-config/state/global-config-dropdown/global-config-dropdown.reducer";
import {buildKitReducer} from "./app/build-kit/state/build-kit/build-kit.reducer";
import {blobFileReducer} from "./app/blob-file/state/blob-file/blob-file.reducer";
import {
  buildKitSettingTemplateReducer
} from "./app/build-kit/state/build-kit-setting-template/build-kit-setting-template.reducer";
import {buildKitPartNumberReducer} from "./app/build-kit/state/build-kit-part-number/build-kit-part-number.reducer";
import {buildKitReportReducer} from "./app/build-kit/state/build-kit-report/build-kit-report.reducer";
import {cadModelReducer} from "./app/cad-model-upload/state/cad-model/cad-model.reducer";
import {
  cadModelRevisionDrawingReducer
} from "./app/cad-model-upload/state/cad-model-revision-drawing/cad-model-revision-drawing.reducer";
import {
  cadModelRevisionMessageReducer
} from "./app/cad-model-upload/state/cad-model-revision-message/cad-model-revision-message.reducer";
import {reportReducer} from "./app/report/state/report/report.reducer";
import {reportTemplateSettingReducer} from "./app/report/state/report-template-setting/report-template-setting.reducer";
import {graphUserReducer} from "./app/admin/state/graph-user/graph-user.reducer";
import {authReducer} from "./app/shared/state/auth/auth.reducer";
import {dropdownDataReducer} from "./app/shared/state/dropdown-data/dropdown-data.reducer";
import {drawingReducer} from "./app/drawing/state/drawing/drawing.reducer";
import {tenantReducer} from "./app/admin/state/tenant/tenant.reducer";
import {bulkUploadReducer} from "./app/admin/state/bulk-upload/bulk-upload.reducer";
import {projectReducer} from "./app/project/state/project/project.reducer";
import {roleReducer} from "./app/user-management/state/role/role.reducer";
import {userReducer} from "./app/user-management/state/user/user.reducer";
import {userInviteReducer} from "./app/user-management/state/user-invite/user-invite.reducer";
import {APP_INITIALIZER, importProvidersFrom, isDevMode, provideZoneChangeDetection} from "@angular/core";
import {provideEffects} from "@ngrx/effects";
import {GlobalConfigEffects} from "./app/global-config/state/global-config/global-config.effects";
import {BuildKitEffects} from "./app/build-kit/state/build-kit/build-kit.effects";
import {RoleEffects} from "./app/user-management/state/role/role.effects";
import {UserEffects} from "./app/user-management/state/user/user.effects";
import {UserInviteEffects} from "./app/user-management/state/user-invite/user-invite.effects";
import {BlobFileEffects} from "./app/blob-file/state/blob-file/blob-file.effects";
import {BuildKitReportEffects} from "./app/build-kit/state/build-kit-report/build-kit-report.effects";
import {
  BuildKitSettingTemplateEffects
} from "./app/build-kit/state/build-kit-setting-template/build-kit-setting-template.effects";
import {BuildKitPartNumberEffects} from "./app/build-kit/state/build-kit-part-number/build-kit-part-number.effects";
import {CadModelEffects} from "./app/cad-model-upload/state/cad-model/cad-model.effects";
import {
  CadModelRevisionDrawingEffects
} from "./app/cad-model-upload/state/cad-model-revision-drawing/cad-model-revision-drawing.effects";
import {
  CadModelRevisionMessageEffects
} from "./app/cad-model-upload/state/cad-model-revision-message/cad-model-revision-message.effects";
import {
  GlobalConfigDropdownEffects
} from "./app/global-config/state/global-config-dropdown/global-config-dropdown.effects";
import {ReportEffects} from "./app/report/state/report/report.effects";
import {ReportSettingTemplateEffects} from "./app/report/state/report-template-setting/report-template-setting.effects";
import {GraphUserEffects} from "./app/admin/state/graph-user/graph-user.effects";
import {AuthEffects} from "./app/shared/state/auth/auth.effects";
import {DropdownDataEffects} from "./app/shared/state/dropdown-data/dropdown-data.effects";
import {DrawingEffects} from "./app/drawing/state/drawing/drawing.effects";
import {TenantEffects} from "./app/admin/state/tenant/tenant.effects";
import {BulkUploadEffects} from "./app/admin/state/bulk-upload/bulk-upload.effects";
import {ProjectEffects} from "./app/project/state/project/project.effects";
import {MessageService} from "primeng/api";
import {InteractionType, PublicClientApplication} from "@azure/msal-browser";
import {msalConfig, protectedResources} from "./app/auth-config";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {provideRouter, RouterModule} from "@angular/router";
import {APP_ROUTES} from "./app.routes";
import {initializeApp} from "./app/app-initializer";
import {GlobalSearchEffects} from "./app/shared/state/global-search/global-search.effects";
import {globalSearchReducer} from "./app/shared/state/global-search/global-search.reducer";
import {DashboardEffects} from "./app/dashboard/state/dashboard.effects";
import {dashboardReducer} from "./app/dashboard/state/dashboard.reducer";
import {drawingMessageReducer} from "./app/build-kit/state/drawing-message/drawing-message.reducer";
import {DrawingMessageEffects} from "./app/build-kit/state/drawing-message/drawing-message.effects";
import {BuildKitDrawingEffects} from "./app/build-kit/state/build-kit-drawing/build-kit-drawing.effects";


bootstrapApplication(AppComponent,
  {
    providers: [
      provideZoneChangeDetection(),provideStore(
        {
          globalConfigs: globalConfigReducer,
          globalConfigDropdowns: globalConfigDropdownReducer,
          buildKits: buildKitReducer,
          blobFileData: blobFileReducer,
          buildKitSettingTemplates: buildKitSettingTemplateReducer,
          buildKitPartNumbers: buildKitPartNumberReducer,
          buildKitReports: buildKitReportReducer,
          cadModels: cadModelReducer,
          cadModelRevisionDrawings: cadModelRevisionDrawingReducer,
          cadModelRevisionMessages: cadModelRevisionMessageReducer,
          reports: reportReducer,
          reportSettingTemplates: reportTemplateSettingReducer,
          graphUsers: graphUserReducer,
          auth: authReducer, // todo: remove?
          dropdownData: dropdownDataReducer,
          drawings: drawingReducer,
          tenants: tenantReducer,
          bulkUpload: bulkUploadReducer,
          projects: projectReducer,
          roles: roleReducer,
          users: userReducer,
          userInvites: userInviteReducer,
          globalSearches: globalSearchReducer,
          dashboards: dashboardReducer,
          drawingMessages: drawingMessageReducer,
        },
      ),
      provideEffects([GlobalConfigEffects, BuildKitEffects, RoleEffects, UserEffects, UserInviteEffects, BlobFileEffects, BuildKitReportEffects, BuildKitSettingTemplateEffects, BuildKitPartNumberEffects, CadModelEffects, CadModelRevisionDrawingEffects, CadModelRevisionMessageEffects, GlobalConfigDropdownEffects, ReportEffects, ReportSettingTemplateEffects, GraphUserEffects, AuthEffects, DropdownDataEffects, DrawingEffects, TenantEffects, BulkUploadEffects, ProjectEffects, GlobalSearchEffects, DashboardEffects, DrawingMessageEffects, BuildKitDrawingEffects, MessageService]),
      importProvidersFrom(
        MsalModule.forRoot(new PublicClientApplication(msalConfig), {
          // The routing guard configuration.
          interactionType: InteractionType.Redirect,
          authRequest: {
            scopes: protectedResources.BrennerSoftwareApi.scopes
          }
        }, {
          interactionType: InteractionType.Redirect,
          protectedResourceMap: new Map([
            [protectedResources.BrennerSoftwareApi.endpoint, protectedResources.BrennerSoftwareApi.scopes]
          ]),
        }),
        // StoreDevtoolsModule.instrument({
        //   maxAge: 25, // Retains last 25 states
        //   logOnly: !isDevMode(), // Restrict extension to log-only mode
        //   autoPause: true, // Pauses recording actions and state changes when the extension window is not open
        //   trace: false, //  If set to true, will include stack trace for every dispatched action, so you can see it in trace tab jumping directly to that part of code
        //   traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
        //   connectInZone: true // If set to true, the connection is established within the Angular zone
        // }),
      ),
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true
      },
      provideAnimationsAsync(),
      providePrimeNG({
        theme: {
          preset: BsPreset,
          options: {
            darkModeSelector: '.my-app-dark'
          }
        }
      }),
      AuthService,
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      // {
      //   provide: ErrorHandler,
      //   useClass: ApplicationinsightsAngularpluginErrorService
      // },
      provideHttpClient(withInterceptorsFromDi()),
      provideRouter(APP_ROUTES),
      {
        provide: APP_INITIALIZER,
        useValue: initializeApp,
        multi: true,
        deps: [MsalService]
      },
    ]


  }).catch(e => console.error(e));
